var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.9745 15.0005C30.9745 22.5765 25.3589 28.8396 18.0639 29.856C17.3818 29.9506 16.6839 30 15.9755 30C15.1578 30 14.3549 29.9348 13.5729 29.8087C6.4313 28.6589 0.976562 22.4661 0.976562 15.0005C0.976562 6.71618 7.69251 0 15.9766 0C24.2606 0 30.9766 6.71618 30.9766 15.0005H30.9745Z",
    fill: "#383D38"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.05872 6.61719L13.9765 15.8664L7.01562 23.3866H8.58268L14.6775 16.8029L19.6015 23.3866H24.9332L17.6266 13.6172L24.1061 6.61719H22.539L16.9266 12.6807L12.3915 6.61719H7.05976H7.05872ZM9.36252 7.77123H11.8114L22.6273 22.2326H20.1785L9.36252 7.77123Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.4dba852cb2947d6518fd03df7909a0b9.svg";
export { ForwardRef as ReactComponent };